import { defineMessages } from 'react-intl';

export const tourStepsMessages = defineMessages({
  transcriptionTitle: {
    defaultMessage: 'Heidi transforms your {specialty} visits into notes',
    id: '7sB8RV/jAf',
    description:
      'Guided-tour transcription screen heading. {specialty} is the clinician\u2019s specialty, e.g. "GP"',
  },
  transcriptionTitleGeneric: {
    defaultMessage: 'Heidi transforms your visits into notes',
    id: 'gnE0aIfPTm',
    description: 'Guided-tour transcription screen heading when the specialty is unknown',
  },
  transcriptionSubtitle: {
    defaultMessage:
      'Focus on your patients while Heidi records your visit in the background.',
    id: 'h/hM11iK9X',
    description: 'Guided-tour transcription screen subheading',
  },
  transcriptionCta: {
    defaultMessage: 'Create my first note',
    id: 'CdVdILgme9',
    description: 'Guided-tour transcription screen primary action',
  },
  detailTitle: {
    defaultMessage: 'Make your notes sound like you',
    id: 'kxsaywVBzD',
    description: 'Guided-tour detail screen heading',
  },
  detailSubtitle: {
    defaultMessage:
      'Customise your voice, and template, to make your notes sound just like you.',
    id: 'afmUPABADT',
    description: 'Guided-tour detail screen subheading',
  },
  noteGeneratingHint: {
    defaultMessage: 'Waiting for your note…',
    id: '8ydf4JkCOX',
    description:
      'Explains why Continue is disabled on any guided-tour task screen while the note those tasks act on is still generating',
  },
  artefactsTitle: {
    defaultMessage: 'Create any document you need',
    id: 'Ubf8pyEzAb',
    description: 'Guided-tour artefacts screen heading',
  },
  artefactsSubtitle: {
    defaultMessage:
      'Automatically fill forms, write referral letters & patient explainers. Anything you need can be created right inside Heidi.',
    id: 'TScpKfyDHO',
    description: 'Guided-tour artefacts screen subheading',
  },
  artefactsContinueHint: {
    defaultMessage: 'Pick a document to continue',
    id: '3ChidbG8Cm',
    description:
      'Explains why Continue is disabled on the guided-tour artefacts screen until a document is created',
  },
  evidenceTitle: {
    defaultMessage: 'Your AI care partner',
    id: 'IOfpyOSHs7',
    description: 'Guided-tour evidence screen heading',
  },
  evidenceSubtitle: {
    defaultMessage:
      'Ask a clinical question and Heidi answers from trusted sources, with citations.',
    id: '798JEsvtcu',
    description: 'Guided-tour evidence screen subheading',
  },
  evidenceEmptyTitle: {
    defaultMessage: 'New chat',
    id: 'SxDTdBJGCz',
    description:
      'Heading in the guided-tour Evidence tab before the clinician asks a question',
  },
  evidenceEmptyBody: {
    defaultMessage: 'Ready to answer your questions...',
    id: 'g0dPFR7HY6',
    description:
      'Supporting line in the guided-tour Evidence tab before the clinician asks a question',
  },
  evidenceAsked: {
    defaultMessage: 'Answer ready in the Evidence tab',
    id: 'QUksIWvVMZ',
    description: 'Confirmation shown on the guided-tour evidence screen after asking',
  },
  evidenceContinueHint: {
    defaultMessage: 'Ask a question to continue',
    id: 'qe3U0k2BvD',
    description:
      'Explains why Continue is disabled on the guided-tour evidence screen until a question is asked',
  },
  completionSubtitle: {
    defaultMessage:
      'We lead the industry in data safety for AI scribes, so you don’t have to think twice about compliance.',
    id: '2XTjwrqGOY',
    description: 'Guided-tour final screen subheading, above the compliance checklist',
  },
  completionConfidenceTitle: {
    defaultMessage: 'Use Heidi with confidence:',
    id: 'CbE4vPlYvb',
    description: 'Heading above the compliance checklist on the guided-tour final screen',
  },
  completionConfidenceEncrypted: {
    defaultMessage: 'Encrypted and hosted in your region',
    id: 'noIy/AF+W8',
    description: 'Compliance checklist item on the guided-tour final screen',
  },
  completionConfidenceTraining: {
    defaultMessage: 'Never used for AI training',
    id: '4rxTAjGgp1',
    description: 'Compliance checklist item on the guided-tour final screen',
  },
  completionConfidenceCertified: {
    defaultMessage: 'Independently certified',
    id: 'pQheMuAmyO',
    description: 'Compliance checklist item on the guided-tour final screen',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'YcQfxnpVYD',
    description: 'Advance to the next guided-tour screen',
  },
  skip: {
    defaultMessage: 'Skip',
    id: 'ws8c0jmmcU',
    description: 'Skip a guided-tour screen',
  },
});
